<template>
    <b-navbar type="dark" variant="secondary" class="app-header navbar">
        <b-navbar-brand
            class="brand-icon"
            :class="{ inactive: isHomePage, filter: isFinished }"
            @click="navigateHome"
        >
            <i class="fa fa-home" />
            <img class="header-logo" src="/static/svg/chloe_logo.svg" alt="" />
        </b-navbar-brand>

        <template v-if="isHomePage">
            <span class="search-and-day" :class="{ search: isFinished }">
                <search-nav-item />
                <filter-by-day v-if="!isFinished" />
            </span>

            <span v-if="isFinished" class="filter-toggle" @click="toggleHandler">
                <b-nav-text v-b-tooltip.hover>
                    <i class="fa fa-sliders" />
                </b-nav-text>
                <span>Filter</span>
            </span>
        </template>

        <b-navbar-nav class="ml-auto">
            <user-menu />
            <span class="name-and-date">
                {{ user.firstName }} {{ user.lastName }} | {{ $uiUtils.formatDate(new Date()) }}
            </span>
        </b-navbar-nav>
    </b-navbar>
</template>

<script>
import { mapState } from 'vuex'
import SearchNavItem from './common/SearchNavItem'
import UserMenu from './partials/UserMenu'
import { SLIDE_TIME_ATTRIBUTION } from '../../business/const'
import FilterByDay from '../components/common/FilterByDay'

export default {
    name: 'AppHeader',
    components: { SearchNavItem, UserMenu, FilterByDay },
    data() {
        return { SLIDE_TIME_ATTRIBUTION }
    },
    computed: {
        ...mapState({
            user: state => state.common.user,
            isShowFilter: state => state.filter.isShowFilter,
            homePageSelectedView: state => state.timelapse.homePageSelectedView
        }),
        isHomePage() {
            return this.$route.name === this.$paths.HOME_PAGE
        },
        isFinished() {
            return this.homePageSelectedView === SLIDE_TIME_ATTRIBUTION.FINISHED
        }
    },
    methods: {
        navigateHome() {
            this.$store.dispatch('navigation/navigateHome')
        },
        toggleHandler() {
            this.$store.commit('filter/changeFilterOption', !this.isShowFilter)
        }
    }
}
</script>

<style lang="scss" scoped>
.app-header {
    padding-left: 0;
    padding-right: 0;
    height: $header-height;
    @include prevent-select();
    background-color: $dark-3 !important;
    z-index: 26;

    i.fa-sliders {
        font-size: 20px;
    }
    .filter-toggle {
        cursor: pointer;
        @media screen and #{$new-break3close} {
            display: none;
        }
    }
    .brand-icon {
        margin: 0;
        padding: 0 1rem 0 0.5rem;
        display: flex;
        align-items: center;
        cursor: pointer;
        z-index: 22;

        .fa-home {
            color: $light;
            font-size: 18pt;
        }
        .header-logo {
            height: 30px;
            margin: 0 1rem;
        }
        &.inactive {
            pointer-events: none;
        }
        &.filter {
            flex: 1;
            @media screen and #{$new-break2close} {
                flex: 0;
            }
        }
        @media screen and #{$new-break2close} {
            .header-logo,
            .brand-name {
                display: none;
            }
        }
    }

    .search-nav-item {
        border-left: 0.1rem solid $dark;
        @media screen and #{$new-break2close} {
            padding-left: 1rem;
        }
        @media screen and #{$new-break3} {
            display: none;
        }
        @media screen and #{$new-break3open} {
            padding-left: 1.5rem;
        }
    }
    .name-and-date {
        display: none;
    }
    .search-and-day {
        display: flex;
        justify-content: end;
        flex: 1;
    }
    .search {
        @media screen and #{$new-break3open} {
            display: none;
        }
    }
}
</style>
